(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mb-coloris"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-mb-coloris]').forEach(function (list) {
    var current = list.querySelector('[aria-current="page"]');
    if (current && list.scrollWidth > list.clientWidth) {
      var cell = current.closest('.mb-coloris__cell') || current;
      list.scrollLeft = Math.max(0, cell.offsetLeft - (list.clientWidth - cell.offsetWidth) / 2);
    }
  });

  /* Carte produit : la pastille survolée (desktop) ou touchée (mobile) pilote l'image, les liens et l'ajout rapide de la carte. Un seul par page. */
  (function () {
    if (window.__mbSwatch) return;
    window.__mbSwatch = true;
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    function cardOf(el) { return el.closest('product-card'); }
    function imgOf(card) {
      var gallery = card.querySelector('product-card-media-gallery');
      return gallery ? gallery.querySelector('.splide__slide img, .product-media img') : null;
    }
    function apply(sw, card) {
      var img = imgOf(card);
      if (img && sw.dataset.mbSrc) {
        if (!('mbSrc' in img.dataset)) {
          img.dataset.mbSrc = img.getAttribute('src') || '';
          img.dataset.mbSrcset = img.getAttribute('srcset') || '';
          img.dataset.mbAlt = img.getAttribute('alt') || '';
        }
        if (img.getAttribute('src') !== sw.dataset.mbSrc) {
          img.setAttribute('srcset', sw.dataset.mbSrcset || '');
          img.setAttribute('src', sw.dataset.mbSrc);
          img.setAttribute('alt', sw.dataset.mbAlt || '');
        }
      }
      var url = sw.dataset.mbUrl;
      if (url) {
        if (!('mbUrl' in card.dataset)) card.dataset.mbUrl = card.dataset.productUrl || '';
        card.dataset.productUrl = url;
        card.productUrl = url;
        card.querySelectorAll('a.product-card-group-link').forEach(function (a) {
          if (!('mbHref' in a.dataset)) a.dataset.mbHref = a.getAttribute('href') || '';
          a.setAttribute('href', url);
        });
      }
      var quick = card.querySelector('quick-add-component');
      var button = quick ? quick.querySelector('[data-ref="add-to-cart-button"]') : null;
      if (button && sw.dataset.mbVariant) {
        if (!('mbVariant' in button.dataset)) { button.dataset.mbVariant = button.dataset.variantId || ''; button.dataset.mbPid = quick.dataset.productId || ''; }
        button.dataset.variantId = sw.dataset.mbVariant;
        button.dataset.productId = sw.dataset.mbPid;
        quick.dataset.productId = sw.dataset.mbPid;
      }
      var list = sw.closest('[data-mb-coloris]');
      if (list) list.querySelectorAll('.mb-coloris__item').forEach(function (item) {
        if (item === sw) item.setAttribute('aria-checked', 'true'); else item.removeAttribute('aria-checked');
      });
      card.__mbSelected = sw;
    }
    function restore(card) {
      var img = imgOf(card);
      if (img && 'mbSrc' in img.dataset) {
        img.setAttribute('srcset', img.dataset.mbSrcset);
        img.setAttribute('src', img.dataset.mbSrc);
        img.setAttribute('alt', img.dataset.mbAlt);
      }
      if ('mbUrl' in card.dataset) { card.dataset.productUrl = card.dataset.mbUrl; card.productUrl = card.dataset.mbUrl; }
      card.querySelectorAll('a.product-card-group-link').forEach(function (a) { if ('mbHref' in a.dataset) a.setAttribute('href', a.dataset.mbHref); });
      var quick = card.querySelector('quick-add-component');
      var button = quick ? quick.querySelector('[data-ref="add-to-cart-button"]') : null;
      if (button && 'mbVariant' in button.dataset) {
        button.dataset.variantId = button.dataset.mbVariant;
        button.dataset.productId = button.dataset.mbPid;
        quick.dataset.productId = button.dataset.mbPid;
      }
      card.querySelectorAll('[data-mb-coloris] .mb-coloris__item').forEach(function (item) {
        if ('mbCurrent' in item.dataset) item.setAttribute('aria-checked', 'true'); else item.removeAttribute('aria-checked');
      });
      card.__mbSelected = null;
    }
    document.addEventListener('mouseover', function (e) {
      if (!fine.matches || !(e.target instanceof Element)) return;
      var sw = e.target.closest('.mb-coloris__item');
      if (!sw) return;
      var card = cardOf(sw);
      if (!card) return;
      apply(sw, card);
      if (!card.__mbLeave) { card.__mbLeave = true; card.addEventListener('mouseleave', function () { restore(card); }); }
    });
    document.addEventListener('click', function (e) {
      if (fine.matches || !(e.target instanceof Element)) return;
      var sw = e.target.closest('.mb-coloris__item');
      if (!sw) return;
      var card = cardOf(sw);
      if (!card) return;
      if (card.__mbSelected === sw) return; /* second tap : le lien de la pastille (ou la carte) s'ouvre */
      e.preventDefault();
      e.stopPropagation();
      apply(sw, card);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mb-compatibilite"] && !Shopify.designMode) return;
  try {
    (function () {
    var fold = function (s) { return (s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim(); };
    var filter = function (dialog) {
      var q = fold((dialog.querySelector('[data-mb-compat-search]') || {}).value);
      var onlyInput = dialog.querySelector('[data-mb-compat-only]');
      var only = onlyInput ? onlyInput.checked : false;
      var shown = 0;
      dialog.querySelectorAll('.mb-compat__row').forEach(function (row) {
        var name = fold(row.querySelector('.mb-compat__name').textContent);
        var show = (!only || row.dataset.ok === 'true') && (!q || name.indexOf(q) !== -1);
        row.hidden = !show;
        if (show) shown++;
      });
      var empty = dialog.querySelector('[data-mb-compat-empty]');
      if (empty) empty.hidden = shown > 0;
    };
    document.addEventListener('input', function (e) {
      if (!e.target.matches('[data-mb-compat-search]')) return;
      filter(e.target.closest('.mb-compat__dialog'));
    });
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-mb-compat-only]')) return;
      filter(e.target.closest('.mb-compat__dialog'));
    });
    /* Un <dialog> descendant d'un lien (carte produit) suivrait le lien à chaque clic : on le sort du lien une fois dialog-component connecté. */
    var detach = function () {
      document.querySelectorAll('[data-mb-compat] .mb-compat__dialog').forEach(function (dialog) {
        if (dialog.closest('a')) document.body.appendChild(dialog);
      });
    };
    document.querySelectorAll('.mb-compat__list').forEach(function (list) {
      var rows = Array.prototype.slice.call(list.children);
      rows.sort(function (a, b) { return fold(a.textContent).localeCompare(fold(b.textContent), 'fr'); });
      rows.forEach(function (r) { list.appendChild(r); });
    });
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('dialog-component').then(function () { setTimeout(detach, 0); });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mb-newsletter"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mbNewsletterInit) return;
    window.__mbNewsletterInit = true;

    var REVISION = '2025-07-15';

    function subscribe(root, email) {
      var company = root.dataset.company;
      var list = root.dataset.list;
      if (!company || !list || !email) return Promise.resolve(false);
      var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company);
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: root.dataset.source || 'Site',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { source_inscription: root.dataset.source || 'Site' }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: list } } }
        }
      };
      return fetch(url, {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', 'revision': REVISION },
        body: JSON.stringify(body)
      }).then(function (r) { return r.ok; }).catch(function () { return false; });
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      var root = form.closest('[data-mb-newsletter]');
      if (!root || form.dataset.mbDone === '1') return;
      var input = form.querySelector('input[type="email"]');
      var email = input ? input.value.trim() : '';
      if (!email) return;
      form.dataset.mbDone = '1';
      subscribe(root, email);
      // Inscrit : la popup de bienvenue (mb-popup-auto) ne s'ouvre plus.
      try { localStorage.setItem('mb:inscrit', '1'); } catch (error) {}
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
